// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

import ArchivedDates from "./components/header";
import Slider from "./components/slider";
import Product from "./components/product-variations";
import Catalogue from "./components/catalogue";
import ProductEnquiry from "./components/productenquiry";

$(document).ready(function(){
  
  ArchivedDates.init();
  Slider.init();
  Product.init();
  Catalogue.init();
  ProductEnquiry.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js